import { BreakpointObserver } from "@angular/cdk/layout";
import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { map } from "rxjs";

import { AuthFacade } from "state/auth.facade";
import { GdprFacade } from "state/gdpr.facade";

import { DropdownContentDirective } from "../dropdown/dropdown-content.directive";
import { DropdownComponent } from "../dropdown/dropdown.component";
import { LanguageMenuItemComponent } from "./language-menu-item/language-menu-item.component";
import { UnitSystemMenuItemComponent } from "./unit-system-menu-item/unit-system-menu-item.component";

@Component({
  selector: "app-profile-dropdown",
  templateUrl: "./profile-dropdown.component.html",
  styleUrls: ["./profile-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    TranslateModule,
    DropdownComponent,
    DropdownContentDirective,
    LanguageMenuItemComponent,
    UnitSystemMenuItemComponent,
  ],
})
export class ProfileDropdownComponent {
  private readonly gdpr = inject(GdprFacade);
  private readonly authFacade = inject(AuthFacade);
  private readonly breakpointObserver = inject(BreakpointObserver);

  private readonly displayName = toSignal(
    this.authFacade.state$.pipe(
      map(({ user, org }) => user?.name ?? user?.email ?? org?.name)
    ),
    { initialValue: "" }
  );

  // Below 500px only the chevron shows, preserving the previous CSS breakpoint.
  private readonly isNarrowScreen = toSignal(
    this.breakpointObserver
      .observe("(max-width: 500px)")
      .pipe(map((result) => result.matches)),
    { initialValue: false }
  );

  protected readonly triggerLabel = computed<string>(() =>
    this.isNarrowScreen() ? "" : (this.displayName() ?? "")
  );

  public logout(): void {
    this.authFacade.logout();
  }

  public openCookieSettings(): void {
    this.gdpr.openSettingsFromMenu();
  }
}
